import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41c0bc77"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["value"];
const _hoisted_2 = { value: '' };
const _hoisted_3 = ["value"];
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHistoricFilter',
    props: {
        connectorsByAudience: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const selectedConnectorIdFilterHistoric = computed(() => store.state['audienceManager'].selectedConnectorIdFilterHistoric);
        const onConnectorChange = (event) => {
            const value = event.target.value;
            const parsedValue = value === '' ? undefined : Number(value);
            store.commit('audienceManager/SET_SELECTED_CONNECTOR_ID_FILTER_HISTORIC', parsedValue);
            store.dispatch('audienceManager/fetchHistoric');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("select", {
                value: selectedConnectorIdFilterHistoric.value,
                onChange: onConnectorChange,
                class: "audience-historic-filter"
            }, [
                _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$t('audiences.all-platforms')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.connectorsByAudience, (connector) => {
                    return (_openBlock(), _createElementBlock("option", {
                        key: connector.id,
                        value: connector.id
                    }, _toDisplayString(connector.name), 9, _hoisted_3));
                }), 128))
            ], 40, _hoisted_1));
        };
    }
});
